import { render, staticRenderFns } from "./TSZ_Usuarios.vue?vue&type=template&id=74205935&"
import script from "./TSZ_Usuarios.vue?vue&type=script&lang=js&"
export * from "./TSZ_Usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports